import { parseProp } from 'mol-ui';
import styled from 'styled-components';

export const FlagContainer = styled.div`
    ${ parseProp('margin') }
`;

export const OptionContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;
